var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.show,"title":"用户中心","close-on-press-escape":false,"close-on-click-modal":false,"fullscreen":"","append-to-body":"","custom-class":"user-center-dialog","before-close":_vm.close},on:{"update:visible":function($event){_vm.show=$event}}},[(_vm.url)?_c('iframe',{attrs:{"src":_vm.url,"frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }